'use strict';

import {applicationModel} from "../../models/applicationmodel.js";
import {responsibleModel} from "../../models/responsiblemodel.js";

export class ApplicationResponsibleCtrl
{
	$scope;
	$filter;
	jsDataService;
	$mdDialog;
	item = {};
	responsible;
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.item = new applicationModel(jsDataService.get('applicationBase', {}), $filter, jsDataService);
		this.resetResponsible();
		this.loadResponsible();
	}
	
	resetResponsible(){
		this.responsible = {
			manager: [],
			evaluator_a: [],
			evaluator_b: [],
			consolidator: [],
			confirmator: [],
			resolutor: []
		};
	}
	
	loadResponsible(){
		if(this.jsDataService.get('cfgDataUrl')){
			this.promise = this.$scope.basicHttpConfigProcess({
				url: this.jsDataService.get('cfgDataUrl'),
				method: 'GET',
				params: {}
			}).then((response) => {
				if(response.data.success){
					this.setResponsibleData(response.data.data);
				}
			}, () => {});
		}
	}
	
	setResponsibleData(data){
		this.resetResponsible();
		for(let row of data){
			if(typeof(this.responsible[row.value]) !== 'undefined'){
				this.responsible[row.value].push(new responsibleModel(row, this.$filter, this.jsDataService));
			}
		}
	}
	
	removeResponsible(ev, responsible){
		if(this.jsDataService.get('cfgRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: responsible.id
					}
				}).then((results) => {
					if(results.data.success){
						this.loadResponsible();
					}
				});
			}, () => {});
		}
	}
	
	editResponsible(ev, responsible){
		this.responsibleEditor(ev, responsible);
	}
	
	addResponsible(ev, typeValue){
		this.responsibleEditor(ev, new responsibleModel({
			id: 0, 
			value: typeValue, 
			user_id: 0, 
			term: 0
		}, this.$filter, this.jsDataService));
	}
	
	responsibleEditor(ev, responsible){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "responsible", "allmembers", this.responsibleEditorDialogCtrl],
			templateUrl: 'application/responsible_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				responsible: responsible,
				allmembers: this.responsible[responsible.value]
			}
		}).then((results) => {
//			console.log('dialog close', results);
			if(this.jsDataService.get('cfgSaveUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgSaveUrl'),
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){
						this.loadResponsible();
					}
				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgSaveUrl'));
			}
		}, () => {});
	}
	
	responsibleEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, responsible, allmembers){
		$scope.responsible = angular.copy(responsible);
		$scope.isSearch = (typeof($scope.responsible.id) === 'undefined' || $scope.responsible.id < 1);
		
		
		$scope.userdata = [];
		$scope.searchString;
		
//		if($scope.responsible.value != 'manager'){
//			if(typeof($scope.responsible.term) !== 'undefined' && $scope.responsible.term > 0){
//				$scope.responsible.termDate = new Date($scope.responsible.term * 1000);
//			}
//			else{
//				$scope.responsible.termDate = new Date();
//			}
//		}
//		else{
//			$scope.responsible.termDate = null;
//		}
		$scope.responsible.termDate = $scope.responsible.term_cet;
		$scope.responsible.termDate.setHours(12);
		
		function getUsers(){
			if(jsDataService.get('cfgUsersUrl')){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('cfgUsersUrl'),
					method: 'GET',
					params: {
						query: $scope.searchString
					}
				}).then((response) => {
					if(response.data.success){
						setData(response.data.data);
					}
				}, () => {});
			}
		}
		
		function inMembersByUid(userId){
			return ($filter('filter')(allmembers, {user_id: userId}, true).length > 0);
		}
		
		
		function setData(data){
			$scope.resetResults();
			for(let u of data){
				u.responsible = u.name + ' ' + u.lastname + ', ' + u.email;
				u.namelastname = u.name + ' ' + u.lastname;
				u.inlist = inMembersByUid(u.id);
				$scope.userdata.push(u);
			}
		}
		if($scope.isSearch){
			$scope.$watch("searchString", (nval, oval) => {
				if(typeof(nval) !== 'undefined' && nval !== ''){
					getUsers();
				}
				else{
					$scope.resetResults();
				}
			});
		}
		
		
		$scope.resetResults = function(){
			$scope.userdata = [];
		};
		
		$scope.assignUser = function(user){
			$scope.responsible.user_id = user.id;
			$scope.responsible.name = user.name;
			$scope.responsible.lastname = user.lastname;
			$scope.responsible.email = user.email;
			$scope.searchString = '';
		};
		
		$scope.hasResults = function(){
			return $scope.userdata.length > 0;
		};
		
		$scope.isValid = function(){
			if(typeof($scope.responsible.user_id) === 'undefined' || $scope.responsible.user_id < 1){
				return false;
			}
			return true;
		};
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function(){
			if($scope.isValid()){
				if($scope.responsible.value != 'manager'){
//					$scope.responsible.term = Math.round($scope.responsible.termDate.getTime() / 1000);
					$scope.responsible.term = $filter('date')($scope.responsible.termDate.getTime(), 'yyyy-MM-dd');
				}
				$mdDialog.hide($scope.responsible);
			}
		}; 
	}
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
	
}